<template>
    <div class="container" v-if="subdomain !== 'sekretariati'">
      <div class="row">
        <div class="d-flex align-items-start boxFrame">
            <div class="nav flex-column nav-pills me-3 w-50" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              <button
                    v-for="tab in tabs"
                    :key="tab.key"
                    class="nav-link text-start leftTab"
                    :class="{ active: currentTab === tab.key } "
                    :id="tab.id"
                    data-bs-toggle="pill"
                    :data-bs-target="tab.target"
                    type="button"
                    role="tab"
                    :aria-controls="tab.target.replace('#', '')"
                    :aria-selected="currentTab === tab.key"
                    @click="currentTab = tab.key">
                    <h3 class="title">{{ tab.title }}</h3>
                    <p class="description">{{ tab.description }}</p>
                    <router-link
                      v-if="tab.route"
                      :to="tab.route"
                      class="link">
                      {{ tab.buttonText }} &nbsp;
                      <font-awesome-icon icon="fa-solid fa-arrow-right" />
                    </router-link>
                    <a
                      v-else
                      @click="currentTab = tab.key"
                      class="link">
                      {{ tab.buttonText }} &nbsp;
                      <font-awesome-icon icon="fa-solid fa-arrow-right" />
                    </a>
                  </button>
            </div>
            <div class="tab-content w-50" id="v-pills-tabContent">
              <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                <!-- <img class="image" src="../../assets/foto1.png" /> -->
                <div class="container bg-white p-5 shadow p-3 mb-5 bg-body">
                  <form>
                    <div class="mb-3">

                    <category-combo-box class="mr-2"
                v-model="formData.prokuroriaId"        :api-url="prokuroriaURL">
                    
                    
                    </category-combo-box>
                      <!-- <label for="contactLocation" class="form-label">Ku dëshironi të na kontaktoni?</label> -->
                      <!-- <select class="form-select" id="contactLocation" required>
                        <option selected>{{this.$t("sistemi_prokurorial.cases.form.select")}}</option>
                        <option v-for="item in denoncoOptions" :key = item>{{item}}</option>
                      </select> -->




                    </div>
              
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <input type="text" class="form-control" v-model="formDataDenonco.emri"  :placeholder="this.$t('sistemi_prokurorial.cases.form.name')" required>
                      </div>
                      <div class="col-md-6 mb-3">
                        <input type="text" class="form-control" v-model="formDataDenonco.mbiemri"  :placeholder="this.$t('sistemi_prokurorial.cases.form.surname')" required>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <input type="email" class="form-control" v-model="formDataDenonco.emailAdresa" :placeholder="this.$t('sistemi_prokurorial.cases.form.email')" required>
                      </div>
                      <div class="col-md-6 mb-3">
                        <input type="text" class="form-control" v-model="formDataDenonco.titulli" :placeholder="this.$t('sistemi_prokurorial.cases.form.title')" required>
                      </div>
                    </div>
                    <div class="mb-3">
                      <input class="form-control" type="file" @change="handleFileChange1" id="formFile">
                    </div>
                    <div class="mb-3">
                      <textarea class="form-control" rows="5" v-model="formDataDenonco.textArea"  :placeholder="this.$t('sistemi_prokurorial.cases.form.message')" required></textarea>
                    </div>
                    <div class="mb-3 d-flex justify-content-between boxButton">
                      <button type="submit" class="btn btn-primary text-white fw-bold sendButton">{{this.$t("sistemi_prokurorial.cases.form.button1")}}</button>
                      <a href="tel:+38344278738" class="btn btn-primary text-white fw-bold sendButton">
                        {{this.$t("sistemi_prokurorial.cases.form.button2")}} <font-awesome-icon icon="fa-solid fa-phone-volume" />
                      </a>
                    </div>
                  </form>
                </div>
              </div>
              <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                <div class="container bg-white p-5 shadow p-3 mb-5 bg-body">
                  <h5>Si viktimë e krimit, ju keni të drejtën:</h5>
                  <p>
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1" />
                    Të trajtoheni me respekt, ndjeshmëri dhe dinjitet dhe në mënyrë profesionale dhe jo diskriminuese nga policia, prokurorët, mbrojtësit e viktimave, gjyqtarët dhe organet tjera me të cilët keni kontakt.<br>
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1" />Të informoheni rreth të drejtave të juaja, pa vonesa që nga kontakti i juaj i parë me policinë, mbrojtësit e viktimave, prokurorët, gjyqtarët dhe organet tjera.<br>
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1" />Të njoftoheni lidhur me rastin tuaj dhe procedurat në polici, prokurori dhe gjykatë.<br>
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1" />Të keni qasjen në ndihmë mjekësore, mbështetjen psikologjike, strehim alternativ,  përfaqësim ligjor dhe ndihmën juridike falas përfshirë këtu edhe përfaqësimin nga Zyra për Mbrojtje dhe Ndihmë Viktimave.<br>
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1" />Të kërkoni mbrojtje duke përfshirë edhe masat mbrojtëse të parapara me ligj.<br>
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1" />Të dëgjoheni nga policia, mbrojtësi i viktimave, prokuroria dhe gjykata.<br>
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1" />Të keni qasje në përkthim pa pagesë nëse nuk e kuptoni gjuhën në të cilën zhvillohet procedura.<br> 
                    <font-awesome-icon icon="fa-solid fa-chevron-right" class="pe-1" />Të keni të drejtë për kompensim nga i dëmtuari në procedurën penale ose të kërkoni kompensim nga Programi për Kompensimin e Viktimave të Krimit.<br>
                  </p>
                </div>
                
              </div>
              <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                <div class="container bg-white p-5 shadow p-3 mb-5 bg-body">
                  <form>
                    <div class="mb-3">
                      <!-- <label for="contactLocation" class="form-label">Ku dëshironi të na kontaktoni?</label> -->
                      <!-- <select class="form-select" id="contactLocation" required>
                        <option selected>{{this.$t("sistemi_prokurorial.cases.form.select")}}</option>
                        <option v-for="item in denoncoOptions" :key = item>{{item}}</option>
                      </select> -->

                          <category-combo-box class="mr-2 "
                v-model="formData.prokuroriaId"        :api-url="prokuroriaURL">
                    
                    
                    </category-combo-box>



                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <input type="text" class="form-control" v-model="formDataLinja.emri"  placeholder="Emri" required>
                      </div>
                      <div class="col-md-6 mb-3">
                        <input type="text" class="form-control" v-model="formDataLinja.mbiemri"  placeholder="Mbiemri" required>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <input type="email" class="form-control" v-model="formDataLinja.emailAdresa" placeholder="Email Adresa" required>
                      </div>
                      <div class="col-md-6 mb-3">
                        <input type="text" class="form-control" v-model="formDataLinja.titulli" placeholder="Titulli" required>
                      </div>
                    </div>
                    <div class="mb-3">
                      <input class="form-control" type="file" @change="handleFileChange2" id="formFile">
                    </div>
                    <div class="mb-3">
                      <textarea class="form-control" rows="5" v-model="formDataLinja.textArea"  placeholder="Shkruani një mesazh..." required></textarea>
                    </div>
                    <div class="mb-3 d-flex justify-content-between boxButton">
                      <button type="submit" class="btn btn-primary text-white fw-bold sendButton">Dërgo denoncimin</button>
                      <a href="tel:+38344278738" class="btn btn-primary text-white fw-bold sendButton">
                        Thirr tani! <font-awesome-icon icon="fa-solid fa-phone-volume" />
                      </a>
                    </div>
                  </form>
                </div>
                <!-- <img class="image" src="../../assets/foto3.png" /> -->
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import { useGlobalStore } from '@/store/global'
import CategoryComboBox from '../share/CategoryComboBox.vue';

export default {
  components: { CategoryComboBox },
    
data() {
  return {
      currentTab: 'denounce',
      prokuroriaURL: 'Prokurorit',
      formData: {
      prokuroriaId: null,
      authorId: null,
      subdomain: '',
    },
    tabs: [
      {
        key: 'denounce',
        title: this.$t("sistemi_prokurorial.cases.denounce.title"),
        description: this.$t("sistemi_prokurorial.cases.denounce.description"),
        buttonText: this.$t("sistemi_prokurorial.cases.denounce.button"),
        target: '#v-pills-home',
        id: 'v-pills-home-tab',
        route: null, // ose lëre null për <a href>
        isActive: true
      },
      {
        key: 'victims_of_crime',
        title: this.$t("sistemi_prokurorial.cases.victims_of_crime.title"),
        description: this.$t("sistemi_prokurorial.cases.victims_of_crime.description"),
        buttonText: this.$t("sistemi_prokurorial.cases.victims_of_crime.button"),
        target: '#v-pills-profile',
        id: 'v-pills-profile-tab',
        route: '/viktimat-e-krimit',
        isActive: false
      },
      {
        key: 'helpline',
        title: this.$t("sistemi_prokurorial.cases.helpline.title"),
        description: this.$t("sistemi_prokurorial.cases.helpline.description"),
        buttonText: this.$t("sistemi_prokurorial.cases.helpline.button"),
        target: '#v-pills-messages',
        id: 'v-pills-messages-tab',
        route: null,
        isActive: false
      }
    ],
    formDataDenonco:{
      selectOption:"",
      emri:"",
      mbiemri:"",
      emailAdresa:"",
      titulli:"",
      file:null,
      textArea:""
    },
    formDataLinja:{
      selectOption:"",
      emri:"",
      mbiemri:"",
      emailAdresa:"",
      titulli:"",
      file:null,
      textArea:""
    }

  }
},
computed:{
  denoncoOptions() {
      const globalStore = useGlobalStore()
      return globalStore.getDenoncoSelect
    }
},
methods:{
  getSubdomain() {
    const host = window.location.hostname;
    if (host.includes('.')) {
      return host.split('.')[0];
    }
    return '';
  },
  handleFileChange1(event) {
    this.formDataDenonco.file = event.target.files[0];
  },

  handleFileChange2(event) {
    this.formDataLinja.file = event.target.files[0];
  },

},
mounted(){
 this.subdomain = this.getSubdomain();
}

};
</script>

<style scoped>
.title {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0%;
  color: #101828;
}

.description {
  font-size: 15px;
  font-weight: 400;
  line-height: 23px;
  letter-spacing: 0%;
  color: #475467;
}

.link {
  font-weight: 600;
  font-size: 13px;
  line-height: 21px;
  letter-spacing: 0%;
  color: #2C3F5E;
  text-decoration: none;
}

.nav .nav-link {
  border-left: 4px solid #F2F4F7;
  border-radius: 0 !important;
}



.nav .active {
  border-left: 4px solid #F5BD2A;
  background-color: transparent !important;
  border-radius: 0 !important;

  -webkit-box-shadow: 0px 0px 10px 0px var(--shadow-color-1); 
  box-shadow: 0px 0px 7px 0px var(--shadow-color-1);

}

.leftTab {
  height: 250px;
  padding: 16px;
}

.image {
  width: 100%;
  height: 540px !important;
  object-fit: cover;
  border-radius: 12px;
  width: 576px;
  float: right;
}

.sendButton {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0%;
  color: #FFFFFF;
  background: #2C3F5E;
  border-radius: 8px;
  padding: 10px 16px;
  text-decoration: none;
  margin: 0 auto;
  margin-top: 32px;
}

/* Desktop Layout */
@media (min-width: 768px) {
  .d-flex {
    display: flex;
    flex-direction: row;
  }
  .nav-pills {
    width: 50%;
  }
  .tab-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }
}

/* Mobile and Tablet Layout */
@media (max-width: 767px) {
  .d-flex {
    flex-direction: column;
  }
  .nav-pills {
    width: 100%;
    margin-bottom: 20px;
  }
  .tab-content {
    width: 100%;
  }
  .leftTab {
    height: auto;
    margin-bottom: 10px;
    border-left: none;
    border-bottom: 3px solid #F2F4F7;
    padding: 12px;
    border-left:none !important;
  }
  .nav .active {
    border-left: none;
    border-bottom: 2px solid #F5BD2A;
  }
  .title {
    font-size: 18px;
    line-height: 26px;
  }
  .description {
    font-size: 14px;
    line-height: 20px;
  }
  .link {
    font-size: 12px;
  }
  .sendButton {
    width: 100%;
    padding: 12px;
    font-size: 14px;
  }
  .mb-3.d-flex {
    flex-direction: column;
    gap: 10px;
  }
  .form-control,
  .form-select {
    font-size: 14px;
    padding: 10px;
  }
  .image {
    height: 300px !important;
    width: 100%;
  }
  .container.bg-white {
    padding: 20px;
  }
  .w-50{
    width:100% !important;
  }
  
}

@media (max-width: 800px) {
  .boxButton{
    flex-direction:column;
  }
  .boxButton button,
  .boxButton a{
    width:100%;
    margin-top:5px;

  }
}

/* Optional: Tablet-specific tweaks */
@media (min-width: 768px) and (max-width: 991px) {
  .leftTab {
    height: 150px;
  }
  .title {
    font-size: 18px;
  }
  .description {
    font-size: 14px;
  }
}

form{
  height:564px;
}

@media(max-width:991px){
  .description{
    display:none;
  }
  .leftTab{
    height:100px;
  }
  .boxFrame{
    flex-direction:column;
  }
  .nav-pills, .tab-content{
    width:100% !important;
  }
  .tab-content{
    margin-top:20px;
  }
}

@media(max-width:767px){
    .form-control,
    .form-select{
      padding:5px;
    }
    .tab-content{
      margin-top:0px !important;
    }
    .leftTab{
      height:80px !important;
    }
    .title{
      margin-bottom:0;
    }
}


</style>